import React from "react";

// Css
import css from "../styles/background.module.scss";

import MouseMove from "../components/MouseMove";

function Background({ children }) {
  return (
    <>
      <div className={css.Background}>
        <MouseMove />

        <div className={css.backgroundWrapper}>{children}</div>
      </div>
    </>
  );
}

export default Background;
